import React, { useCallback, useEffect } from "react";
import styles from "./CartCounter.module.scss";
import { useSharedCart } from "../../entrypoints/theme";
import Bag from "../Icons/Bag";

interface CartState {
  main_items_count: number;
}

interface SharedCartHook {
  cartState: CartState | null;
  openMiniCart: () => void;
  fetchCart: () => Promise<void>;
}

const CartCounter = React.memo(() => {
  const { cartState, openMiniCart, fetchCart } =
    useSharedCart() as SharedCartHook;

  const handleSubmit = (event: React.FormEvent<HTMLFormElement>): void => {
    // Quick fix for color product, we can remove this once we have a better solution
    const productTags = document.querySelector(
      "#product_tags"
    ) as HTMLInputElement;
    fetchCart().finally(() => {
      const notCustom = productTags.value.includes("Hidden-Metafields");
      if (notCustom && !window.location.pathname.startsWith("/cart")) {
        console.log("Reloading cart");
        setTimeout(() => {
          window.location.reload();
        }, 500);
      }
    });
  };

  const handleClick = useCallback(
    (event: React.MouseEvent<HTMLDivElement>): void => {
      event.stopPropagation();
      if (!window.location.pathname.startsWith("/cart")) {
        openMiniCart();
        document.body.classList.add("no-scroll");
      }

      const cartDrawer = document.querySelector(".ajax-cart");
      if (cartDrawer) {
        cartDrawer.classList.add("is-active");
        cartDrawer.classList.add("is-visible");
      }
    },
    [openMiniCart]
  );

  useEffect(() => {
    const formDOM = document.querySelector(".product-form") as HTMLFormElement;
    const submitHandler = (event: Event) =>
      handleSubmit(event as React.FormEvent<HTMLFormElement>);

    if (formDOM) {
      formDOM.addEventListener("submit", submitHandler);
    }
    // Initial fetch when the component mounts
    fetchCart();

    // Add listener for pageshow event (handles bfcache)
    const handlePageShow = (event: PageTransitionEvent): void => {
      // If the page is loaded from the back/forward cache
      if (event.persisted) {
        console.log("from bfcache");
        // Re-fetch cart data
        fetchCart();
      }
    };

    window.addEventListener("pageshow", handlePageShow);

    // Cleanup: remove the listeners when the component unmounts
    return () => {
      window.removeEventListener("pageshow", handlePageShow);
    };
  }, [fetchCart]);

  return (
    <div
      id="swfCartButton"
      className={styles.cartCounterContainer}
      onClick={handleClick}
    >
      <div className={styles.cartIcon}>
        <Bag />
      </div>
      {cartState && (
        <span className={styles.cartCount}>{cartState.main_items_count}</span>
      )}
    </div>
  );
});

// Visible for debugging
CartCounter.displayName = "CartCounter";

export default CartCounter;
